var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty"},[_c('el-image',{staticStyle:{"width":"345px","height":"160px"},attrs:{"src":_vm.emptyImg,"fit":"cover"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }